// Angular
import { ChangeDetectorRef, Component } from '@angular/core';
// Layout
import { LayoutConfigService, OffcanvasOptions } from '../../../../core/_base/layout';
import { OnInit } from '@angular/core';
import { ajaxservice } from '../../../../services/ajaxservice'; // Common API service for both get and post
import { Router } from '@angular/router';

@Component({
	selector: 'kt-sticky-toolbar',
	templateUrl: './sticky-toolbar.component.html',
	styleUrls: ['./sticky-toolbar.component.scss'],
})
export class StickyToolbarComponent implements OnInit {
	// Public properties
	demoPanelOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-demo-panel',
		closeBy: 'kt_demo_panel_close',
		toggleBy: 'kt_demo_panel_toggle',
	};

	baseHref: string;
	employee_code: any;
	role_id: any;
	notifiy: any;
	constructor(private chRef: ChangeDetectorRef,private layoutConfigService: LayoutConfigService, public ajax: ajaxservice, private router: Router,) {
		this.employee_code = localStorage.getItem('pro_employee_code');
		console.log(this.employee_code, "employee code");
		this.role_id = localStorage.getItem('pro_role_id');
		console.log(this.role_id);
		this.baseHref = 'https://keenthemes.com/metronic/preview/angular/';
	}
	ngOnInit(): void {
		this.employee_code = localStorage.getItem('pro_employee_code');
		console.log(this.employee_code, "employee codefgedfgdfgvf");
	}
	notification() {
		console.log("notification")
		if (this.role_id == 4 || this.role_id == 5) {
			console.log("notification role")
			this.specific_notify();
			this.chRef.detectChanges();
		}
		else {
			this.notifiy = [];
		}
	}
	specific_notify() {
		this.notifiy = [];
		var url = 'notify/?';
		var id = "employee_code"
		var code = this.employee_code;
		this.ajax.getdataparam(url, id, code).subscribe((result) => {
			if (result.response.response_code == "200" || result.response.response_code == "400") {                    //if sucess
				this.notifiy = result.response.data;                    //storing the api response in the array
				this.chRef.detectChanges();
				/* inputOptions can be an object or Promise */
				// for (var index1 in notifiy) {
				// 	console.log(notifiy[index1].status, "notifiy[index1].Description")
				// 	Swal.fire({
				// 		title: "Notification",
				// 		text: notifiy[index1].Description,
				// 		// text:notifiy[index1].count,
				// 		// html:'<kt-service-notification></kt-service-notification>',
				// 		icon: 'info',
				// 		showCancelButton: true,
				// 		confirmButtonText: 'Redirect',
				// 		cancelButtonText: 'OK'
				// 	}).then((result) => {
				// 		console.log(notifiy[index1].status, "notifiy[index1].Description")
				// 		if (result.value) {
				// 			if (notifiy[index1].status == "New Ticket") {
				// 				if (role_id == 4) {
				// 					this.router.navigate(['/newticket']);
				// 				}
				// 				else if (role_id == 5) {
				// 					this.router.navigate(['/manager_newticket']);
				// 				}

				// 			}

				// 		}
				// 	})
				// }
			}

		}, (err) => {
			console.log(err);
		});
	}
	redirectpage(status: any) {
		console.log(status, "status")
		if (status == "New Ticket") {
			if (this.role_id == 4) {
				this.router.navigate(['/newticket']);
			}
			else if (this.role_id == 5) {
				this.router.navigate(['/manager_newticket']);
			}

		}
		else if (status == "Ticket Spare") {
			if (this.role_id == 5) {
				this.router.navigate(['/spare_request']);
			}
		}
		else if (status == "Imprest Spare") {
			if (this.role_id == 5) {
				this.router.navigate(['/imprest_spare']);
			}
		}
		else if (status == "Spare Transfer") {
			if (this.role_id == 5) {
				this.router.navigate(['/transfer_spare']);
			}
		}
		else if (status == "New Contract") {
			if (this.role_id == 5) {
				this.router.navigate(['/manager_contract']);
			}
		}
		else if (status == "Discount Request") {
			if (this.role_id == 5) {
				this.router.navigate(['/discount_approve']);
			}
		}
		// this.demoPanelOptions.closeBy;
	}
	isActiveDemo(demo: any) {
		return demo === this.layoutConfigService.getConfig('demo');
	}
}
